// =====================================
//
//   顯示報價單商品規格的 Controller
//   Author: Gray
//   createtime: 2017 / 07 / 27
//
// =====================================

window.InifECApp.directive('offeritemSpec', ['ProductUtil', function(ProductUtil) {

    var _dir = {};

    var controller = ['$scope',function ($scope) {

        var PdtSpecProps = ProductUtil.PdtSpecProps;

        // ------------------------------
        // init
        // ------------------------------
    	var init = function() {

    		if(!$scope.offeritem) {
    			return;
    		}

            $scope.spec = $scope.offeritem.spec;
            $scope.specProps = $scope.spec.specProps;
	    }

        // ------------------------------
        // 取得尺寸
        // ------------------------------
        var getSizeUnit = function(key) {

            var specProps = $scope.specProps;
            var unit = specProps[key];

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // 取得尺寸
        // ------------------------------
        var getSizeUnitByInt = function(unit) {

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // 取得衣服尺寸代碼文字
        // ------------------------------
        var getClothingSizeUnitText = function(clothingSize) {

            var text = '';

            if(!clothingSize) {
                return text;
            }            

            if(clothingSize.clothingSizeunit === ProductUtil.ClothingSizeUnit.CUSTOM) {
                text = text + clothingSize.customSizeName;
            } else {
                text = text + ProductUtil.getClothingSizeUnitText(clothingSize.clothingSizeunit);
            }

            // if(clothingSize.remark) {
            //     text = text + '(' + clothingSize.remark + ')';
            // }

            return text;
        }

        // ------------------------------
        // [SCOPE] 取得顏色style
        // ------------------------------
        var getColorBackgroundStyle = function(color) {

            if(!color || !color.hex) {
                return undefined;
            }

            if(color.subHex) {
                return {
                    background: 'linear-gradient(-45deg, ' + color.subHex + ' 50%, ' + color.hex + ' 50%)',
                };
            } else {
                return {
                    backgroundColor: color.hex,
                }
            }
        }

        //==========================
        //  Event
        //==========================
        $scope.$watchGroup(['offeritem', 'offeritem.spec'], function(newValues, oldValues, scope) {
            init();
        });

        //==========================
        //  Members
        //==========================
        $scope.spec = undefined;
        $scope.specProps = undefined;
        $scope.offeritem;
        $scope.PdtSpecProps = PdtSpecProps;

        //==========================
        //  Methods
        //==========================
        $scope.getSizeUnit = getSizeUnit; // 取得尺寸
        $scope.getSizeUnitByInt = getSizeUnitByInt; // 取得尺寸
        $scope.getClothingSizeUnitText = getClothingSizeUnitText; // 取得衣服尺寸代碼文字
        $scope.getColorBackgroundStyle = getColorBackgroundStyle; // 取得顏色style

        //==========================
        //  Init
        //==========================
        // init();

    }];

    _dir.restrict = 'AE';
    _dir.scope = {
        offeritem: "=",
    };
    _dir.replace = true;
    _dir.templateUrl = "partials/directives/offeritem_spec.html";
    _dir.controller = controller;

    return _dir;

}]);
